import { render } from "./AgencyRating.vue?vue&type=template&id=032724d9&scoped=true"
import script from "./AgencyRating.vue?vue&type=script&lang=ts"
export * from "./AgencyRating.vue?vue&type=script&lang=ts"

import "./AgencyRating.vue?vue&type=style&index=0&id=032724d9&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-032724d9"

export default script